<template>
  <div class="search">
    <el-row :gutter="10">
      <!-- <el-col :xs="6" :sm="6" :md="6" :lg="3" v-if="showHide" style="margin-bottom: 5px;">
        <div class="screen">省市区筛选</div>
      </el-col>-->
      <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;">
        <el-select
          v-model="searchForm.provinceId"
          placeholder="请选择省"
          @change="chooseProvince($event)"
          style="width:100%"
        >
          <el-option
            v-for="item in province"
            :key="item.id"
            :label="item.area_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;">
        <el-select
          v-model="searchForm.cityId"
          style="width:100%"
          placeholder="请选择市"
          @change="chooseCity($event)"
        >
          <el-option v-for="item in city" :key="item.id" :label="item.area_name" :value="item.id"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;">
        <el-select
          v-model="searchForm.districtId"
          placeholder="请选择区"
          @change="chooseDistrict($event)"
          style="width:100%"
        >
          <el-option
            v-for="item in district"
            :key="item.id"
            :label="item.area_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :xs="6"
        :sm="6"
        :md="4"
        :lg="3"
        v-if="this.role==1||this.role==2"
        style="margin-bottom: 5px;"
      >
        <el-select v-model="searchForm.evaluator_rank" placeholder="请选择等级" style="width:100%">
          <el-option
            v-for="(item,index) in grade"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="6" v-if="!showHide" style="margin-bottom: 5px;">
        <div class="block">
          <el-date-picker
            v-model="testTime"
            type="datetimerange"
            start-placeholder="测试开始日期"
            end-placeholder="测试结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            prefix-icon="el-icon-date"
            style="width:100%;"
          ></el-date-picker>
        </div>
      </el-col>
      <el-col :xs="8" :sm="8" :md="4" :lg="3" style="margin-bottom: 5px;" v-if="role==1">
        <el-input placeholder="输入测试班名称" v-model="searchForm.keyword"></el-input>
      </el-col>
      <el-col :xs="8" :sm="8" :md="4" :lg="4" style="margin-bottom: 5px;" v-if="role==2">
        <el-input :placeholder="word" v-model="searchForm.keyword"></el-input>
      </el-col>
      <el-col :xs="8" :sm="8" :md="4" :lg="4" style="margin-bottom: 5px;" v-if="role==3">
        <el-input placeholder="输入测试机构名称" v-model="searchForm.keyword"></el-input>
      </el-col>
      <el-col :xs="16" :sm="12" :md="8" :lg="3" style="margin-bottom: 5px;" v-if="role==1">
        <el-button @click="search">
          <i class="el-icon-search"></i>
        </el-button>
        <el-button @click="clear">
          <i class="el-icon-delete"></i>
        </el-button>
      </el-col>
      <el-col
        :xs="10"
        :sm="12"
        :md="8"
        :lg="4"
        style="margin-bottom: 5px;"
        v-if="role==2||role==3 "
      >
        <el-button @click="search">
          <i class="el-icon-search"></i>
        </el-button>
        <el-button @click="clear">
          <i class="el-icon-delete"></i>
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { GetDistrictList, GetDicData } from "@/api/admin/common.js";
export default {
  props: ["showHide", "role"],
  data() {
    return {
      province: [],
      city: [],
      district: [],
      grade: [],
      searchForm: {},
      testTime: [],
      path: "",
      reFresh: true,
      word:''
    };
  },
  watch: {
    "searchForm.provinceId"(val) {
      GetDistrictList({ parent_id: val }).then(data => {
        this.city = data.data.result.items;
        // this.searchForm.city = this.city[0].id;
        // this.chooseCity(this.searchForm.city);
        this.searchForm.cityId = "";
        this.searchForm.districtId = "";
      });
    },
    $route(to) {
      this.path = to.path;
      // 考评员培训和列表搜索文本框的文字显示
      if(this.path=='/evaluationStaffTraining'){
        this.word='输入考评班名称'
      }
      else if(this.path=='/evaluationList'){
        this.word='输入考评员名字'
      }
      this.clear();
    },
  },
  created() {
    this.getDistrictList();
    this.path = this.$route.path;
      // 考评员培训和列表搜索文本框的文字显示
      if(this.path=='/evaluationStaffTraining'){
        this.word='输入考评班名称'
      }
      else if(this.path=='/evaluationList'){
        this.word='输入考评员名字'
      }
      this.clear();
  },
  methods: {
    // word(){
    //  
    // },
    search() {
      if (this.role == 1) {
        if(this.testTime){
          let condition = {
            provinceId: this.searchForm.provinceId,
            cityId: this.searchForm.cityId,
            districtId: this.searchForm.districtId,
            evaluator_rank: this.searchForm.evaluator_rank,
            keyword: this.searchForm.keyword,
            startTime: this.testTime[0],
            endTime: this.testTime[1]
          };
          this.searchBus.$emit("SearchData2", condition); //触发事件
        }
        else{
          let condition = {
            provinceId: this.searchForm.provinceId,
            cityId: this.searchForm.cityId,
            districtId: this.searchForm.districtId,
            evaluator_rank: this.searchForm.evaluator_rank,
            keyword: this.searchForm.keyword,
            startTime: '',
            endTime: ''
          };
          this.searchBus.$emit("SearchData2", condition); //触发事件
        }
      } else if (this.role == 2) {
        let condition = {
          provinceId: this.searchForm.provinceId,
          cityId: this.searchForm.cityId,
          districtId: this.searchForm.districtId,
          evaluator_rank: this.searchForm.evaluator_rank,
          keyword: this.searchForm.keyword
        };
        this.searchBus.$emit("SearchData", condition); //触发事件
      } else {
        let condition = {
          provinceId: this.searchForm.provinceId,
          cityId: this.searchForm.cityId,
          districtId: this.searchForm.districtId,
          evaluator_rank: this.searchForm.evaluator_rank,
          keyword: this.searchForm.keyword
        };
        this.searchBus.$emit("SearchData3", condition); //触发事件
      }
    },
    clear() {
      this.searchForm = {};
      this.district = [];
      this.search();
    },
    getDistrictList() {
      
      // 区域列表
      GetDistrictList({ parent_id: "-1" }).then(data => {
        if (data.data.result) {
          this.province = data.data.result.items;
        }
      });
      //可申请等级
      if (this.role == 1) {
        GetDicData({ classCode: "test_class_can_apply_for_grade" }).then(
          data => {
            if (data.data.result) {
              this.grade = data.data.result;
            }
          }
        );
      } else if (this.role == 2) {
        GetDicData({ classCode: "appraiser_grade" }).then(data => {
          if (data.data.result) {
            this.grade = data.data.result;
          }
        });
      }
    },
    chooseProvince(item) {
      GetDistrictList({ parent_id: item }).then(data => {
        this.city = data.data.result.items;
      });
    },
    chooseCity(item) {
      GetDistrictList({ parent_id: item }).then(data => {
        this.searchForm.districtId = "";
        this.district = data.data.result.items;
        // this.searchForm.district = this.district[0].id;
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="less">
.search {
  margin: 15px 0px;
  .el-input-group__append:hover {
    opacity: 0.7;
  }
  .screen {
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #ffffff;
  }
}
</style>
